import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Form, Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { numberFormat } from "../../utils/numberFormat";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from "moment";
import { Link } from "react-router-dom";
import { fetchAllDataAPI, filterByParams } from "../../utils/api";
import ContentWrapper from "../../components/contentwrapper/ContentWrapper";
import ReportNavBar from "../../components/ReportNavBar";
import withAuth from "../../utils/withAuth";

const CenterPerformance = () => {
    const [report, setReport] = useState([]);
    const [filteredReport, setFilteredReport] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [dateRange, setDateRange] = useState({
        startDate: new Date().toLocaleDateString('en-US'),
        endDate: new Date().toLocaleDateString('en-US'),
    });

    useEffect(() => {
        getCenterPerformanceReport();
    }, []);

    const getCenterPerformanceReport = async () => {
        setIsLoading(true);
        try {
            const res = await fetchAllDataAPI("ppc-get-cluster-head-performance-report-last-two-months");
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        } catch (error) {
            console.error("Error fetching report:", error);
        }
        setIsLoading(false);
    };

    const handleFilterByDate = async (event, picker) => {
        setIsLoading(true);
        const selectedRange = {
            startDate: picker.startDate.format("YYYY-MM-DD"),
            endDate: picker.endDate.format("YYYY-MM-DD")
        };
        setDateRange(selectedRange);
        try {
            const res = await filterByParams("ppc-get-filter-cluster-head-performance-report-last-two-months", selectedRange);
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        } catch (err) {
            console.error(err);
        }
        setIsLoading(false);
    };

    const handleReset = async () => {
        setSearchTerm("");
        const defaultRange = {
            startDate: moment().subtract(2, 'months').startOf('month').toDate(),
            endDate: moment().subtract(1, 'months').endOf('month').toDate()
        };
        setDateRange(defaultRange);
        setIsLoading(true);
        try {
            const res = await fetchAllDataAPI("ppc-get-filter-cluster-head-performance-report-last-two-months");
            if (res.data.status === 1) {
                setReport(res.data.report);
                setFilteredReport(res.data.report);
            }
        } catch (error) {
            console.error("Reset fetch error:", error);
        }
        setIsLoading(false);
    };

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filteredData = report.filter(item =>
            item.cluster_head_name?.toLowerCase().includes(value)
        );
        setFilteredReport(filteredData);
    };

    const grandTotal = filteredReport.find(item => item.cluster_head_name.toLowerCase() === 'grand_total');

    return (
        <div className="misDashboard">
            <Helmet>
                <title>SATKARTAR: CLUSTER HEAD PERFORMANCE</title>
            </Helmet>
            <ContentWrapper>
                <ReportNavBar />
                <div className="card p-2 mt-2" style={{ marginBottom: "50px" }}>
                    <div className="heading d-flex justify-content-between mb-2">
                        <h5 className="mb-0 text-uppercase mt-2" style={{fontWeight:"500"}}>
                            Cluster Head Performance Report from {filteredReport[0]?.last_month_name || 'Last Month'} to {filteredReport[0]?.current_month_name || 'This Month'}
                        </h5>
                        <div className="mt-1">
                            <Form.Control
                                type="text"
                                placeholder="Search by Cluster Head Name"
                                value={searchTerm}
                                onChange={handleSearch}
                                className="mb-3"
                            />
                        </div>
                        <div className="d-flex">
                            <span onClick={handleReset} className="btnreset">Reset</span>
                            <div className="btnpicker">
                                <DateRangePicker
                                    initialSettings={{
                                        startDate: dateRange.startDate,
                                        endDate: dateRange.endDate,
                                    }}
                                    onApply={handleFilterByDate}
                                >
                                    <button className="btn btn-md btndaterange">Select Date Range</button>
                                </DateRangePicker>
                            </div>
                        </div>
                    </div>
                    <div className="table pagetable table-responsive">
                        <Table className="table-sm table-fixeds" responsive striped bordered hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Cluster Head Name</th>
                                    <th>{filteredReport[0]?.last_month_name || "Last Month"}</th>
                                    <th>{filteredReport[0]?.current_month_name || "Current Month"} Till Date</th>
                                    <th>Growth (%)</th>
                                    <th>Yesterday Total Order</th>
                                    <th>Delivered(%)</th>

                                    <th>
                                        01–10{" "}
                                        {moment(dateRange?.endDate).format("MMM")}(%)
                                    </th>
                                    <th>
                                        11–20{" "}
                                        {moment(dateRange?.endDate).format("MMM")}(%)
                                    </th>
                                    <th>
                                        21–{moment(dateRange?.endDate).endOf("month").format("DD")}{" "}
                                        {moment(dateRange?.endDate).format("MMM")}(%)
                                    </th>

                                    <th>Ticket Size</th>
                                </tr>
                            </thead>
                            <tbody>
                                {isLoading ? (
                                    [...Array(5)].map((_, index) => (
                                        <tr key={index}>
                                            {Array.from({ length: 11 }).map((_, i) => (
                                                <td key={i}><Skeleton animation="wave" variant="text" /></td>
                                            ))}
                                        </tr>
                                    ))
                                ) : filteredReport.length > 0 ? (
                                    filteredReport
                                        .filter(item => item.cluster_head_name.toLowerCase() !== 'grand_total')
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td><Link style={{letterSpacing:"0.8px",fontWeight:"700"}} to={`/center-head-performance-report/${item.center_id}`}>{item.cluster_head_name}</Link></td>
                                                <td>{numberFormat(item.last_month_total)}</td>
                                                <td>{numberFormat(item.current_month_total)}</td>
                                                <td style={{ fontWeight: "600", color: item.growth_percentage >= 0 ? "green" : "red" }}>
                                                    {item.growth_percentage !== null ? Number(item.growth_percentage).toFixed(2) + "%" : "N/A"}
                                                </td>
                                                <td>{numberFormat(item.yesterday_total)}</td>
                                                <td
                                                    style={{
                                                        color: item.delivery_percentage >= 50 ? "white" : "inherit",
                                                        background: item.delivery_percentage >= 50 ? "green" : "inherit",
                                                        fontWeight: item.delivery_percentage >= 50 ? "bold" : "normal"
                                                    }}
                                                >
                                                    {item.delivery_percentage ? item.delivery_percentage + "%" : "N/A"}
                                                </td>
                                                <td
                                                    style={{
                                                        color: item.block_01_10_delivery_percentage >= 50 ? "white" : "inherit",
                                                        background: item.block_01_10_delivery_percentage >= 50 ? "green" : "inherit",
                                                        fontWeight: item.block_01_10_delivery_percentage >= 50 ? "bold" : "normal"
                                                    }}
                                                >
                                                    {item.block_01_10_delivery_percentage ? item.block_01_10_delivery_percentage + "%" : "N/A"}
                                                </td>
                                                <td
                                                    style={{
                                                        color: item.block_11_20_delivery_percentage >= 50 ? "white" : "inherit",
                                                        background: item.block_11_20_delivery_percentage >= 50 ? "green" : "inherit",
                                                        fontWeight: item.block_11_20_delivery_percentage >= 50 ? "bold" : "normal"
                                                    }}
                                                >
                                                    {item.block_11_20_delivery_percentage ? item.block_11_20_delivery_percentage + "%" : "N/A"}
                                                </td>
                                                <td
                                                    style={{
                                                        color: item.block_21_till_delivery_percentage >= 50 ? "white" : "inherit",
                                                        background: item.block_21_till_delivery_percentage >= 50 ? "green" : "inherit",
                                                        fontWeight: item.block_21_till_delivery_percentage >= 50 ? "bold" : "normal"
                                                    }}
                                                >
                                                    {item.block_21_till_delivery_percentage ? item.block_21_till_delivery_percentage + "%" : "N/A"}
                                                </td>
                                                <td>{numberFormat(item.ticket_size)}</td>
                                            </tr>
                                        ))
                                ) : (
                                    <tr>
                                        <td colSpan="11" className="text-center">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                            <tfoot>
                                {grandTotal && (
                                    <tr style={{ backgroundColor: "#f8f9fa", fontWeight: "bold" }}>
                                        <th colSpan={1} style={{ fontWeight: "700", color: "#000" }}>#</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>Grand Total</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{numberFormat(grandTotal.last_month_total)}</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{numberFormat(grandTotal.current_month_total)}</th>
                                        <th style={{ fontWeight: "700", color: grandTotal.growth_percentage >= 0 ? "green" : "red" }}>
                                            {grandTotal.growth_percentage !== null ? Number(grandTotal.growth_percentage).toFixed(2) + "%" : "N/A"}
                                        </th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{numberFormat(grandTotal.yesterday_total)}</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{grandTotal.delivery_percentage ? grandTotal.delivery_percentage + "%" : "N/A"}</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{grandTotal.block_01_10_delivery_percentage ? grandTotal.block_01_10_delivery_percentage + "%" : "N/A"}</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{grandTotal.block_11_20_delivery_percentage ? grandTotal.block_11_20_delivery_percentage + "%" : "N/A"}</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{grandTotal.block_21_till_delivery_percentage ? grandTotal.block_21_till_delivery_percentage + "%" : "N/A"}</th>
                                        <th style={{ fontWeight: "700", color: "#000" }}>{numberFormat(grandTotal.ticket_size)}</th>
                                    </tr>
                                )}
                            </tfoot>
                        </Table>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    );
};

export default withAuth(CenterPerformance);
